import {useContext, useState} from "react";
import {AnimatePresence, motion} from "framer-motion";
import { dataContext } from "../../../context/context";
import './cases.css';
import {useMediaQuery} from "react-responsive";
import CasesGaleryDesktop from "./casesGaleryDesktop";
import  CasesGaleryMobile  from "./casesGaleryMobile"


function Cases() {
    const { data, loading, error, isBY, isRU, isLocal } = useContext(dataContext);
    const [showItems, setShowItems] = useState(false);
    const [showItems2, setShowItems2] = useState(false);

    let urlPrefix = "/images/";
    if (isLocal) urlPrefix = "https://sushi-tunec.com" + urlPrefix;

    const isMobile = useMediaQuery({ query: "(max-width: 1000px)" });



        const section = data.sectionsdata.find(s => s.nick === 'cases');
        const paragraphs = section ? section.paragraphsdata : [];
        const paragraph = paragraphs.filter(p => p.nick === 'cases2');

        return (
            <>
            <motion.section
                id="cases"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true, amount: 0.25 }}
                transition={{ duration: 1, delay: 0.5 }}
                >

                <h2>{section.title}</h2>

                <div className="inner_block">
                  {   isMobile ? (
                             <CasesGaleryMobile />
                         ) : (
                             <CasesGaleryDesktop />
                         )
                   }

                </div>
            </motion.section>
            <motion.section
                id="doubt"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: true, amount: 0.25 }}
                transition={{ duration: 1, delay: 0.5 }}
                onAnimationComplete={() => {
                    setShowItems(true);
                }}
            >
                  <div className="inner_block">
                      <div className="doubt-textblock">

                      <h2>Развеем ваши сомнения</h2>

                      {
                          paragraph.map((par) => (

                              <>

                                  <h3>{par.title}</h3>
                                  {par.text}


                                  { par.galerydata.length > 0 && !isMobile && (
                                      <div className="galery">

                                          {
                                              par.galerydata.map((gal, index) => (

                                                  <motion.div
                                                      key={index}
                                                      initial={{ opacity: 0, y: 10, scale: 0.5 }}
                                                      animate={ showItems ? { opacity: 1, y: 0, scale: 1 } : {}}
                                                      transition={{ delay: index * 0.3, duration: 0.3 }}
                                                      className="galery_item"
                                                  >
                                                      <img src={urlPrefix + gal.image} />

                                                      {
                                                          gal.text.map((line, index2) => (
                                                              <span key={index2}>{line}<br /></span>
                                                          ))
                                                      }

                                                  </motion.div>

                                              ))
                                          }
                                      </div>
                                  )}

                              </>

                          ))
                      }

                  </div>
                  </div>

            </motion.section>


                {  isMobile && (

                <motion.section
                    id="doubtgalery"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true, amount: 0.25 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    onAnimationComplete={() => {
                        setShowItems2(true);
                    }}
                >


                            {
                                paragraph.map((par) => (

                                    <>

                                    { par.galerydata.length > 0 && (
                                            <div className="galery">

                                                {
                                                    par.galerydata.map((gal, index) => (

                                                        <motion.div
                                                            key={index}
                                                            initial={{ opacity: 0, x: 200 }}
                                                            animate={ showItems2 ? { opacity: 1, x: 0 } : {}}
                                                            transition={{ delay: index * 0.3, duration: 0.3 }}
                                                            className="galery_item"
                                                        >
                                                            <img src={urlPrefix + gal.image} />

                                                            {
                                                                gal.text.map((line, index2) => (
                                                                    <span key={index2}>{line}<br /></span>
                                                                ))
                                                            }

                                                        </motion.div>

                                                    ))
                                                }
                                            </div>

                                        )}
                                    </>

                                ))
                            }

                </motion.section>
                )}


            </>
        )


}

export default Cases;